<div class="sales-order-sidebar-bulk-update">
  <lum-app-integration-shipping-options-form
    [selectedRows]="selectedRows"
    [currentShippingPreset]="currentPreset"
    [appIntegrationAccountId]="appIntegrationAccountId"
    [commonAppIntegrationAccountId]="commonAppIntegrationAccountId"
    [loading]="loadingBulkUpdateShippingLabel"
    [actionTitle]="'Update'"
    [hideCancel]="true"
    [hasSameAppIntegrationId]="hasSameAppIntegrationId"
    [message]="bulkUpdateWarningMessage"
    (submitEvent)="onSubmit($event)"
  ></lum-app-integration-shipping-options-form>
</div>
